import React, { useEffect, useState } from 'react';
import Input from '@/components/input/input';
import Select from '@/components/input/select';
import { defaultSelectOptions } from '@/pages/statistics/reports/filters/filterParametrs';
import { FilterStore } from '@/store';
var WaitTimeFilters = function (_a) {
    var handleSetFilters = _a.handleSetFilters;
    var filterParams = FilterStore.useState(function (s) { return s.initialParams; });
    var totalOptionValue = defaultSelectOptions.find(function (el) { return el.value === filterParams.total_wait_time.split(' ')[0]; });
    var awgOptionValue = defaultSelectOptions.find(function (el) { return el.value === filterParams.avg_wait_time.split(' ')[0]; });
    var _b = useState({
        value: totalOptionValue ? totalOptionValue.value : '',
        name: totalOptionValue ? totalOptionValue.name : '',
    }), totalOption = _b[0], setTotalOption = _b[1];
    var _c = useState({
        value: awgOptionValue ? awgOptionValue.value : '',
        name: awgOptionValue ? awgOptionValue.name : '',
    }), awgOption = _c[0], setAwgOption = _c[1];
    var _d = useState(filterParams.total_wait_time.split(' ')[1]), totalValue = _d[0], setTotalValue = _d[1];
    var _e = useState(filterParams.avg_wait_time.split(' ')[1]), awgValue = _e[0], setAwgValue = _e[1];
    var handleSelect = function (_a) {
        var option = _a.option, name = _a.name;
        switch (name) {
            case 'total_wait_time':
                if (option.value === '') {
                    setTotalOption({
                        value: '',
                        name: '',
                    });
                    setTotalValue(undefined);
                    handleSetFilters(name, 'all');
                    break;
                }
                setTotalOption(option);
                break;
            case 'avg_wait_time':
                if (option.value === '') {
                    setAwgOption({
                        value: '',
                        name: '',
                    });
                    setAwgValue(undefined);
                    handleSetFilters(name, 'all');
                    break;
                }
                setAwgOption(option);
                break;
        }
    };
    var handleInput = function (e) {
        var _a = e.target, value = _a.value, name = _a.name;
        switch (name) {
            case 'total_wait_time':
                setTotalValue(value);
                handleSetFilters(name, "".concat(totalOption.value, " ").concat(value));
                break;
            case 'avg_wait_time':
                setAwgValue(value);
                handleSetFilters(name, "".concat(awgOption.value, " ").concat(value));
                break;
        }
    };
    useEffect(function () {
        if (totalValue) {
            handleSetFilters('total_wait_time', "".concat(totalOption.value, " ").concat(totalValue));
        }
        if (awgValue) {
            handleSetFilters('avg_wait_time', "".concat(awgOption.value, " ").concat(awgValue));
        }
    }, [totalOption, awgOption]);
    return (<div className="report_filters__box">
      <p className="report_filters__title">Длительность ожидания</p>
      <div className="report_filters__input">
        <p className="report_filters__input-text">Общая</p>
        <Select width={264} name="total_wait_time" placeholder="Выбрать" value={totalOption.name !== '' ? totalOption.name : undefined} onChange={handleSelect} options={defaultSelectOptions}/>
      </div>
      <div className="report_filters__input">
        <p className="report_filters__input-text">Минут</p>
        <Input type="number" name="total_wait_time" width={264} onChange={handleInput} value={totalValue} disabled={totalOption.name === ''}/>
      </div>
      <div className="report_filters__input">
        <p className="report_filters__input-text">Средняя</p>
        <Select width={264} name="avg_wait_time" placeholder="Выбрать" value={awgOption.name !== '' ? awgOption.name : undefined} onChange={handleSelect} options={defaultSelectOptions}/>
      </div>
      <div className="report_filters__input">
        <p className="report_filters__input-text">Минут</p>
        <Input type="number" name="avg_wait_time" width={264} onChange={handleInput} value={awgValue} disabled={awgOption.name === ''}/>
      </div>
    </div>);
};
export default WaitTimeFilters;
